export enum ProIntegrationsApplicationFormField {
  ApiError = 'api_error',
  ShopUrl = 'shop_url',
  ItemTypes = 'item_types',
  ItemAmount = 'item_amount',
  ItemValue = 'item_value',
  MonthlyListings = 'monthly_listings',
  ApiImplementation = 'api_implementation',
  ThirdParty = 'third_party',
  TermsOfUse = 'terms_of_use',
}

export enum ProIntegrationsApplicationFormApiImplementation {
  Self = 'self',
  ThirdParty = 'third_party',
}
